@if (isTrialActive() && resume() && !activeStep()) {
    <div class="guided-trial-resume-wrap">
        <button class="guided-trial-resume" (click)="returnToGuide()" data-testid="guided-trial-resume-button">
            <span class="resume-arrow">&#8592;</span>
            <span class="resume-text">
                <span class="resume-label">{{ "discovery.resume_guide" | translate }}</span>
                <span class="resume-feature">{{ resume()!.label }}</span>
            </span>
        </button>
        <button class="guided-trial-resume-dismiss" (click)="dismissResume()" data-testid="guided-trial-resume-dismiss-button">&#10005;</button>
    </div>
}
